var layoutStyles = {"column":"modal__column_eeppb","gap-16":"modal__gap-16_eeppb","gap-24":"modal__gap-24_eeppb","gap-32":"modal__gap-32_eeppb","start":"modal__start_eeppb","center":"modal__center_eeppb","space-between":"modal__space-between_eeppb"};
require('./components/footer/layout.css')

export { layoutStyles as l };
